import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { AddAccountFormContainerViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import LiteralsService from 'src/services/literals/LiteralsService';

import BasicInput from 'src/components/formik-fields/basic-input/BasicInput';
import CurrencyInput from 'src/components/formik-fields/currency-input/CurrencyInput';
import DefaultFormButtons from './defaultFormButtons/DefaultFormButtons';
import ManualAccountService from 'src/services/manualAccount.service';

import styles from './addAccountFormContainer.module.scss';

export default function AddAccountFormContainer({
    initialValues = {
        name: '',
        amount: ''
    },
    validationSchema = Yup.object({
        name: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
        amount: Yup.number()
            .required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull'))
            .typeError(LiteralsService.getLiteral('Onboarding.forms.inputValidationTypeNumber'))
    }),
    manualAccount,
    onSubmit,
    handleBack,
    children = (
        <>
            <BasicInput id="name" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.name')} />
            <CurrencyInput
                id="amount"
                label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.currentBalance')}
            />
        </>
    )
}: AddAccountFormContainerViewModel): JSX.Element {
    const secondaryOnclick = async (): Promise<void> => {
        void ManualAccountService.deleteAccount(manualAccount);
        handleBack();
    };

    return (
        <Formik
            initialValues={
                manualAccount?.investmentHolding
                    ? { ...manualAccount?.investmentHolding, ...initialValues }
                    : { ...initialValues, ...manualAccount?.debt }
            }
            validationSchema={validationSchema}
            onSubmit={(values) => {
                void onSubmit(values);
            }}
        >
            <Form className={styles.form}>
                {children}
                <DefaultFormButtons update={!!manualAccount} secondaryOnclick={secondaryOnclick} />
            </Form>
        </Formik>
    );
}
